var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('circle',{staticClass:"center",attrs:{"r":"3","cx":_vm.normalizeX(_vm.point.x),"cy":_vm.normalizeY(_vm.point.y)}})}
var staticRenderFns = []

export { render, staticRenderFns }